import type { ReactNode } from "react";
import Breadcrumbs, { type Crumb } from "@/components/base/Breadcrumbs";

interface PageHeaderProps {
  crumbs: Crumb[];
  eyebrow?: string;
  title: string;
  description?: string;
  children?: ReactNode;
}

export default function PageHeader({
  crumbs,
  eyebrow,
  title,
  description,
  children,
}: PageHeaderProps) {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6 py-8 md:py-12">
        <Breadcrumbs items={crumbs} />
        <div className="mt-6 md:mt-8 max-w-3xl">
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.3em] uppercase text-primary-600 mb-3">
              <span className="block w-6 h-px bg-primary-400"></span>
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            {title}
          </h1>
          {description && (
            <p className="mt-3 md:mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              {description}
            </p>
          )}
        </div>
        {children}
      </div>
    </section>
  );
}